/**
 * OpenClaw settings — VOICE tab.
 *
 * A thin host around `VoiceControls`, which owns the toggle, the org-curated
 * picker, the 409 `VOICE_NOT_ALLOWED` race handling and the `voice`
 * kill-switch lock. The controls were extracted (assistant-hub S6) so the
 * SAME logic backs the hero's voice chip popover — one write path, two homes.
 *
 * This tab is the interim home and dies with the gear dialog's Voz entry once
 * the chip fully replaces it; until then nothing about voice is unreachable.
 */
import { VoiceControls } from "./VoiceControls";

export function VoiceTab() {
  return <VoiceControls />;
}
